import React from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import { useTheme } from '@mui/material'

export default function LinearProgressCustom(props) {
  const theme = useTheme()

  return (
    <LinearProgress
      sx={{
        backgroundColor: `rgba(${theme.palette.primary.light.replace(/[rgb\(\)]+/g, '')}, 0.3)`,
        '& .MuiLinearProgress-bar': {
          backgroundColor: theme.palette.primary.main
        }
      }}
      {...props}
    />
  )
}
